import type { IconButtonProps } from '@_/ui';
import clsx from 'clsx';
import { PiThumbsUpLight } from 'react-icons/pi';
import { FormattedNum, IconButton } from '@_/ui';

interface LikeIconButtonProps extends IconButtonProps {
  hasLiked?: boolean;
  numLikes?: string | number;
}

export function LikeIconButton({
  disabled = false,
  hasLiked = false,
  numLikes = 0,
  subdued,
  ...otherProps
}: LikeIconButtonProps) {
  return (
    <IconButton
      animate
      ariaLabel="like"
      disabled={disabled}
      icon={<PiThumbsUpLight />}
      iconClassName={clsx(
        hasLiked
          ? 'text-primary-500 group-hover:text-primary-600'
          : clsx(
              disabled && 'text-gray-300',
              subdued
                ? 'text-gray-400 group-hover:text-gray-500'
                : 'text-gray-600 group-hover:text-gray-800'
            )
      )}
      label={numLikes ? <FormattedNum compact value={numLikes} /> : undefined}
      labelClassName={clsx('text-semibold', hasLiked ? 'text-primary-700' : 'text-gray-700')}
      {...otherProps}
    />
  );
}
